import i18n from '@/i18n/config';

import { RouteException } from './RouteException';

export class ForbiddenRouteException extends RouteException {
  constructor() {
    super(
      'forbidden',
      i18n.t('Acceso no permitido'),
      i18n.t('Lamentamos no poder mostrarte este contenido, necesitas permisos para acceder')
    );
  }
}
